export const Impersonation = 'system/impersonate';
export const ImpersonateCountry = 'system/impersonate-country';
export const ViewSiteVersionNumber = 'system/view-site-version';

export const ManageFeatureFlags = 'feature-flags/manage';
export const ManageEditingStyles = 'editing-styles/manage';

export const HandleSpecialAuthorizations = 'special-authorizations';

export const ViewLogs = 'logs/view';
export const ViewHelpPortal = 'help/view';

export const ViewImageEditors = 'image-editors/view';
export const CreateImageEditor = 'image-editors/create';
export const UpdateImageEditor = 'image-editors/update';
export const DeleteImageEditor = 'image-editors/delete';

export const ViewProducts = 'products/view';
export const CreateProducts = 'products/create';
export const UpdateProducts = 'products/update';

export const ListProductTypes = 'product-types/list';
export const CreateProductType = 'product-types/create';
export const UpdateProductType = 'product-types/update';
export const DeleteProductType = 'product-types/delete';

export const ViewProductGroups = 'product-groups/view';
export const CreateProductGroup = 'product-group/create';

export const ListPlanFirms = 'plan-firms/list';
export const CreatePlanFirm = 'plan-firms/create';
export const UpdatePlanFirm = 'plan-firms/update';
export const DeletePlanFirm = 'plan-firms/delete';

export const ListStylingFirms = 'styling-firms/view';
export const CreateStylingFirm = 'styling-firms/create';
export const UpdateStylingFirm = 'styling-firms/update';
export const DeleteStylingFirm = 'styling-firms/delete';

export const ListStylingUsers = 'styling-user/view';

export const ViewStylingCalendar = 'styling-user/view-calender';
export const ViewStylingCalendars = 'styling-user/view-calenders';

export const ViewStylingOrder = 'styling-admin/order/view';
export const ViewCommentsToStylingUser = 'styling-admin/order/view-comments-to-styling-user';
export const UpdateCommentsToStylingUser = 'styling-admin/order/update-comments-to-styling-user';

export const ViewRegions = 'regions/view';

export const ViewBrokerTree = 'broker-tree/view';
export const MoveBrokerTreeNode = 'broker-tree/move';
export const CreateBrokerTreeNode = 'broker-tree/create';
export const UpdateBrokerTreeNode = 'broker-tree/update';
export const DeleteBrokerTreeNode = 'broker-tree/delete';
export const RestoreBrokerTreeNode = 'broker-tree/restore';

export const ListBrokerAgents = 'broker-agents/list';
export const EditHeadOffice = 'broker-agents/edit-head-office';
export const SendAgentPasswordLink = 'broker-agents/password-link';

export const ListSe360Users = 'se360-users/list';
export const CreateSe360Users = 'se360-users/create';
export const UpdateSe360Users = 'se360-users/update';
export const DeleteSe360Users = 'se360-users/delete';
export const RestoreSe360Users = 'se360-users/restore';

export const ViewPhotographers = 'photographers/view';
export const UpdatePhotographers = 'photographers/update';
export const CreatePhotographers = 'photographers/create';

export const ViewAgreements = 'agreements/view';
export const CreateAgreements = 'agreements/create';
export const UpdateAgreements = 'agreements/update';
export const DeleteAgreements = 'agreements/delete';

export const ListPlanEditors = 'plan-editors/list';
export const CreatePlanEditor = 'plan-editors/create';
export const UpdatePlanEditor = 'plan-editors/update';
export const DeletePlanEditor = 'plan-editors/delete';

export const CreateLegalEntity = 'legal-entity/create';
export const ListLegalEntity = 'legal-entity/list';
export const UpdateLegalEntity = 'legal-entity/update';
export const DeleteLegalEntity = 'legal-entity/delete';

export const ReadStatistics = 'statistics/read';
export const ExportStatisticsToExcel = 'statistics/excel-export';

export const FavoriteImages = 'se360-user/favorite-images';

export const ListOrders = 'orders/list-orders';
export const ListPlanOrders = 'orders/list-plan-orders';
export const ListPhotoOrders = 'orders/list-photo-orders';
export const ListFilmOrders = 'orders/list-film-orders';
export const ListDigitalStylingOrders = 'orders/list-digital-styling-orders';
export const UploadFilm = 'orders/upload-film';
export const SendFilm = 'orders/send-film';
export const FilterOrderListOnBrokerAgent = 'orders/list-orders/filter-on-broker-agent';

export const DigitalStyling_DownloadUneditedImages = 'digital-styling/download-unedited-images';
export const DigitalStyling_DownloadEditedImages = 'digital-styling/download-edited-images';
export const DigitalStyling_UploadCustomerFiles = 'digital-styling/upload-customer-files';
export const DigitalStyling_UploadFiles = 'digital-styling/upload-files';
export const DigitalStyling_DeleteFiles = 'digital-styling/delete-files';
export const DigitalStyling_DeleteCustomerFiles = 'digital-styling/delete-customer-files';
export const DigitalStyling_ViewCustomerFiles = 'digital-styling/view-customer-files';
export const DigitalStyling_ViewUneditedFiles = 'digital-styling/view-unedited-files';
export const DigitalStyling_ViewEditedFiles = 'digital-styling/view-edited-files';
export const DigitalStyling_SendInCustomerFiles = 'digital-styling/send-in-customer-files';
export const DigitalStyling_DeliverEditedImages = 'digital-styling/deliver-edited-images';
export const DigitalStyling_ViewOrderData = 'digital-styling/view-order-data';
export const DigitalStyling_DownloadDeliveredImages = 'digital-styling/download-delivered-images';

export const ListBookingOrders = 'orders/list-booking-orders';
export const MarkBookingOrderAsUnread = 'orders/mark-booking-order-as-unread';
export const BookOrdersWithoutTraveltime = 'orders/book-orders-without-traveltime';
export const ListAdvanceSearchOrders = 'orders/advance-search-list-orders';
export const ViewArchivedOrder = 'orders/view-archived-order';
export const ViewArchiveStatusForArchivedOrder = 'orders/view-archive-status-for-archived-order';
export const ViewUnarchiveStatusForOrder = 'orders/view-unarchive-status-order';
export const UnarchiveArchivedOrder = 'orders/unarchive-archived-order';
export const ViewSampleImagesForArchivedOrder = 'orders/view-sample-images-for-archived-order';
export const ViewNotes = 'orders/view-notes';

export const UpdateIsDirectDelivery = 'orders/update-is-direct-delivery';

export const CreateOrder = 'orders/create-order';
export const CreateOwnOrder = 'orders/create-own-order';
export const ViewOrder = 'orders/view-order';
export const ViewBasicOrderInfo = 'orders/view-basic-order-info';
export const AssistCreateOrder = 'orders/assist-create-order';
export const ViewOrderContactInfo = 'orders/view-order-contact-info';
export const EditOrder = 'orders/edit-order';
export const OrderAssignUser = 'orders/assign-user';
export const ViewPlanOrder = 'plan-orders/view';
export const ViewPlanOrderWhenMeasured = 'plan-orders/view-when-measured';
export const ViewAdminPlanOrder = 'plan-orders/admin-view';
export const AdminGrabPlanOrder = 'plan-orders/admin-view/grab';
export const CreateGenericOrder = 'orders/create-generic-order';
export const CreateOrderInSameOrderCollection = 'orders/create-order-in-same-order-collection';
export const ViewOrderCollection = 'orders/view-order-collection';
export const UpdateOrderCollectionName = 'orders/update-order-collection-name';
export const ViewPhotographerCompensationInOrderCollection =
    'orders/view-photographer-compensation-in-order-collection';
export const PlanEditorOrdersEditUpdatePlanEditorWithoutConfirmation =
    'plan-orders/plan-editor/edit/update-plan-editor-without-confirmation';
export const ViewPlanEditorColumn = 'plan-orders/plan-editor/view/plan-editor-column';
export const ViewUngrabbedPlanOrder = 'plan-orders/plan-editor/view/ungrabbed';
export const DeleteDeliveryFile = 'plan-orders/delete-delivery-file';
export const AnnotateDeliveryFile = 'plan-orders/annotate-delivery-file';
export const AnnotateExternalAnnotationFile = 'annotate-external-annotation-file';
export const CropDeliveryFile = 'plan-orders/crop-delivery-file';

export const UpdateOwnerCommunicationLanguage = 'orders/view/update-owner-communication-language';
export const UpdateImageEditorFirm = 'orders/view/update-image-editor-firm';
export const OrderUpdateImageEditor = 'orders/view/update-image-editor';
export const UpdateExtraDeliveryRecipients = 'orders/view/update-extra-delivery-recipients';
export const SetOrderToUploader = 'orders/view/set-order-to-uploader';
export const UpdateOrderState = 'orders/view/set-order-state';

export const ResetContentProviderDelivery = 'orders/reset-content-provider-delivery';

export const ViewProductPriceBrokerFirm = 'orders/view-product-price-broker-firm';
export const ViewPhotographerCompensation = 'orders/view-photographer-compensation';
export const ProductPricePropertyOwner = 'orders/product-price-property-owner';
export const ViewInvoiceComment = 'orders/view-invoice-comment';
export const ViewPhotographerComment = 'orders/view-photographer-comment';

export const AddOrderRow = 'orders/add-order-row';
export const ChangeOrderRow = 'orders/change-order-row';

export const ViewOrderCommunications = 'orders/view-order-communications';
export const CreateOrderCommunication = 'orders/create-order-communication';

export const UploadPhotographs = 'photographer-uploads/upload';
export const ViewPhotographerOrders = 'photographer-uploads/view-orders';

export const CreatePlanTemplate = 'plan-template/create';

export const ListTemplates = 'templates/list';
export const CreateTemplates = 'templates/create';
export const UpdateTemplates = 'templates/update';
export const DeleteTemplates = 'templates/delete';

export const ViewUneditedImages = 'image-processing/view-unedited-images';
export const ViewEditedImages = 'image-processing/view-edited-images';
export const ViewDeliveredEditedImages = 'image-processing/view-delivered-edited-images';
export const AddEditedImages = 'image-processing/add-edited-images';
export const SetNeedsEditing = 'image-processing/set-needs-editing';
export const UpdateCommentToEditor = 'image-processing/update-comment-to-editor';
export const UpdateCommentFromEditor = 'image-processing/update-comment-from-editor';
export const UpdateCommentToPhotographer = 'image-processing/update-comment-to-photographer';
export const UpdateCommentFromPhotographer = 'image-processing/update-comment-from-photographer';
export const UpdateInternalComment = 'image-processing/update-internal-comment';
export const UpdateFilename = 'image-processing/update-filename';
export const UpdateCategory = 'image-processing/update-category';
export const UpdateCategoryWhenFlex = 'image-processing/update-category-when-flex';
export const DownloadImages = 'image-processing/download-images';
export const DownloadHighResolutionImage = 'image-processing/download-high-resolution-image';
export const DownloadEditedImages = 'image-processing/download-edited-images';
export const UploadFailedImages = 'image-processing/upload-failed-images';
export const ViewImageEditorComments = 'image-processing/view-image-editor-comments';
export const DoneEditingImages = 'image-processing/done-editing-images';
export const ApproveImagesBySE360 = 'image-processing/approve-images-by-se360';
export const ApproveImagesByCustomer = 'image-processing/approve-images-by-customer';
export const ApproveImagesByPhotographer = 'image-processing/approve-images-by-photographer';
export const ReDeliverImages = 'image-processing/re-deliver-images';
export const ViewCommentsForPhotographer = 'image-processing/view-comments-for-photographer';
export const ViewCommentsForImageEditor = 'image-processing/view-comments-for-imageeditor';
export const ViewCommentsForAll = 'image-processing/view-comments-for-all';
export const ViewOrderCommentsForSe360 = 'image-processing/view-order-comments-for-se360';
export const ViewOrderCommentsForImageEditor =
    'image-processing/view-order-comments-for-imageeditor';
export const DeleteUneditedImage = 'image-processing/delete-unedited-image';
export const UploadUneditedImage = 'image-processing/upload-unedited-image';
export const UploadNormalImage = 'image-processing/upload-normal-image';
export const DeleteEditedImage = 'image-processing/delete-edited-image';
export const ReturnEditedImage = 'image-processing/return-edited-image';
export const ViewUneditedOrdersPage = 'image-processing/view-unedited-orders-page';
export const ViewHighResolutionImageZoom = 'view-high-resolution-image-zoom';
export const DownloadNormalImage = 'image-processing/download-normal-image';
export const EditCustomerImages = 'image-processing/edit-customer-images';
export const HandleEditedImagesWhenPhotographerIsEditor =
    'image-processing/handle-edited-images-when-photographer-is-editor';
export const ViewInformationToPhotographer = 'image-processing/view-information-to-photographer';
export const ViewInformationToImageEditor = 'image-processing/view-information-to-image-editor';
export const ViewInformationForSe360 = 'image-processing/view-information-for-se360';
export const ViewInformationFromFirm = 'image-processing/view-information-from-firm';
export const ViewInformationFromChain = 'image-processing/view-information-from-chain';
export const CanUploadImagesAnyTime = 'image-processing-can-upload-imagesany-time';
export const CreateStitchedImage = 'image-processing/create-stitched-image';
export const PlacePinOnImage = 'image-processing/place-pin-on-image';
export const ViewNeedsEditing = 'image-processing/view-needs-editing';
export const AdministrateImageEditors = 'image-processing/administrate-image-editors';
export const ViewPhotographerInstructions = 'image-processing/view-photographer-instructions';
export const ResetRejectedImages = 'image-processing/reset-rejected-images';
export const DeleteImagesAcceptedOrder = 'image-processing/delete-images-accepted-order';
export const DeleteImagesAcceptedUpload = 'image-processing/delete-images-accepted-upload';

export const ViewCalendar = 'photographers/viewcalendar';

export const ViewCustomerCalendar = 'customers/view-calendar';

export const CreateCommonTexts = 'common-text/create';

export const ViewPhotographerAgreement = 'photographer-agreement/view';

export const CreateInvoices = 'orders/create-invoices';
export const ViewInvoices = 'orders/view-invoices';

export const ViewCopyOrder = 'orders/view/view-copy-order';
export const DeliverCopyOrder = 'orders/view/deliver-copy-order';
export const ViewCopywriterOnOrder = 'orders/view/view-copywriter-on-order';
export const ChangeCopywriterOnOrder = 'orders/view/change-copywriter-on-order';

export const ViewOwnPhotographerInvoices = 'photographer-invoice/view-own';
export const ViewAllPhotographerInvoices = 'photographer-invoice/view-all';
export const CreatePhotographerInvoice = 'photographer-invoice/create';
export const RejectPhotographerInvoice = 'photographer-invoice/reject';
export const UnlockRejectedPhotographerInvoice = 'photographer-invoice/unlock';
export const CreatePhotographerInvoiceCollection = 'photographer-invoice-collection/create';
export const GeneratePhotographerInvoiceCollectionFiles = 'photographer-invoice-collection/file';

export const ListInvoiceProductType = 'invoice-product-type/list';
export const CreateInvoiceProductType = 'invoice-product-type/create';
export const EditInvoiceProductType = 'invoice-product-type/edit';

export const ManageInvoiceProductType = 'orders/invoice-product-types/manage';

export const ViewPayments = 'orders/view-payments';
export const CreatePayments = 'orders/create-payments';
export const CreditInvoice = 'orders/credit-invoice';
export const DisplaySite = 'orders/display-site';

export const ListInvoiceJournals = 'invoice-journals/list';
export const GetInvoiceJournal = 'invoice-journals/get';

export const ListPaymentJournals = 'payment-journals/list';
export const GetPaymentJournal = 'payment-journals/get';

export const ViewReceivable = 'receivable/view';

export const ViewImageEditorFirms = 'image-editor-firms/view';
export const CreateImageEditorFirms = 'image-editor-firms/create';
export const UpdateImageEditorFirms = 'image-editor-firms/update';

export const PlanEditorOrdersList = 'plan-orders/plan-editor/list';

export const EditPhotographerBookingExecutionTime =
    'se360-user/photographer-booking/edit-execution-time';
export const EditPhotographerBookingAdvanceMode = 'se360-user/photographer-booking/advance-mode';

export const EditUserName = 'profile/edit-username';

export const SuperSearchAccess = 'super-search/view';

export const ViewStatistics = 'statistics/view';
export const ViewEconomicStatistics = 'statistics/view/economics';

export const ViewUneditedFuturePhotoOrderList = 'orders/view-unedited-future-photo-orders-list';

export const PlanAnnotateViewHistory = 'plans/annotate-view-history';

export const HideRemovedOrderRows = 'orders/view/hide-removed-order-rows';

export const ViewDetailedPlanOrderStatus = 'orders/view/detailed-plan-order-status';
export const MoveOrder = 'orders/move';
export const CloneOrders = 'order/clone';
export const SwapPlanOrders = 'plan-orders/swap';

export const HideDeliveryFailure = 'plan-orders/hide-delivery-failure';

export const LockPhotographer = 'orders/view/lock-photographer';
export const ViewOrderIfLocked = 'orders/view-order-if-locked';
export const ViewBookedScandphotoPhotographerInfoRegardlessTime =
    'orders/view-booked-scandphotos-photographer-info-regardless-time';

export const DeleteExternalFile = 'plan-orders/delete-external-file';

export const ListCopywriters = 'copywriter/list-copywriters';

export const ViewSEPlaySlideshow = 'image-processing/update-imagegallery-image';

export const ExportToProcountor = 'zentuvo-invoicing/export-to-procountor';

export const NewsEditor = 'news-editor/view';

export const CreateCustomerAgreements = 'customer-agreements/create';
export const EditCustomerAgreements = 'customer-agreements/edit';
export const AssignCustomerAgreements = 'customer-agreements/assign';
export const ViewAssignedCustomerAgreements = 'customer-agreements/view-assigned';

export function hasFeature(feature: string, loggedInUser: any) {
    let user = loggedInUser;
    return (
        user && user.details && user.details.features && user.details.features.indexOf(feature) > -1
    );
}

export function hasNotFeature(feature: string, loggedInUser: any) {
    return hasFeature(feature, loggedInUser) === false;
}

export function hasAnyFeature(features: string[], loggedInUser: any) {
    return features.some((x) => hasFeature(x, loggedInUser));
}
